import { useState } from "react";
import { Button, ButtonGroup, Menu, MenuItem, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTranslation } from "react-i18next";

interface AddConditionActionsProps {
    onAddLogicalGroup?: (operator: "and" | "or") => void;
    onAddExists?: (operator?: "and" | "or") => void;
    useGenericAdd?: boolean;
}

export const AddConditionActions = ({
    onAddLogicalGroup,
    onAddExists,
    useGenericAdd = false,
}: AddConditionActionsProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
    const menuOpen = Boolean(menuAnchorEl);

    if (!onAddLogicalGroup && !onAddExists) {
        return null;
    }

    const closeMenu = () => setMenuAnchorEl(null);

    return (
        <>
            <ButtonGroup
                size="small"
                variant="outlined"
                orientation={isMobile ? "vertical" : "horizontal"}
                sx={{ width: { xs: "100%", sm: "auto" }, flexShrink: 0 }}
            >
                {onAddLogicalGroup && useGenericAdd && (
                    <Button onClick={() => onAddLogicalGroup("and")}>{t("Add condition")}</Button>
                )}
                {onAddLogicalGroup && !useGenericAdd && (
                    <>
                        <Tooltip title={t("Add AND condition")}>
                            <Button onClick={() => onAddLogicalGroup("and")} sx={{ minWidth: 45 }}>
                                {t("AND")}
                            </Button>
                        </Tooltip>
                        <Tooltip title={t("Add OR condition")}>
                            <Button onClick={() => onAddLogicalGroup("or")} sx={{ minWidth: 45 }}>
                                {t("OR")}
                            </Button>
                        </Tooltip>
                    </>
                )}
                {onAddExists && (
                    <Tooltip title={t("More condition actions")}>
                        <span>
                        <Button
                            aria-label={String(t("More condition actions"))}
                            title={String(t("More condition actions"))}
                            onClick={(event) => setMenuAnchorEl(event.currentTarget)}
                            sx={{ minWidth: 34, px: 0.75 }}
                        >
                            <ArrowDropDownIcon fontSize="small" />
                        </Button>
                        </span>
                    </Tooltip>
                )}
            </ButtonGroup>

            {onAddExists && (
                <Menu
                    anchorEl={menuAnchorEl}
                    open={menuOpen}
                    onClose={closeMenu}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <MenuItem
                        onClick={() => {
                            onAddExists("and");
                            closeMenu();
                        }}
                    >
                        {t("EXISTS")}
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            onAddExists("or");
                            closeMenu();
                        }}
                    >
                        {t("OR EXISTS")}
                    </MenuItem>
                </Menu>
            )}
        </>
    );
};
